/**
 * Cleans href or src value so it only allows http and mailto
 *
 * IMPORTANT: Plz update shared/da-editor/src/components/utils/browser.ts also
 * when you update this function, circular deps...
 *
 * TODO move into da-hooks or some other higher level dep
 *
 * @param linkOrSrc
 * @returns
 */
function cleanLinkSrc(linkOrSrc) {
  try {
    const url = new URL(linkOrSrc ?? '');
    if (url && (url.username || url.password)) {
      return '';
    }

    if (!['http:', 'https:', 'mailto:'].includes(url.protocol)) {
      return '';
    }
  } catch {
    return '';
  }

  return linkOrSrc;
}

export default cleanLinkSrc;
